export default __webpack_public_path__ + "cbe7e4efe5ed0c4368d4dcbbb6c93768.png";